import { jsx as o } from "react/jsx-runtime";
import { VStack as g } from "@chakra-ui/react";
import { Suggestion as n } from "./Suggestion.mjs";
import { useAutoSuggestionContext as u } from "./useAutoSuggestionContext.mjs";
const p = ({ ...e }) => {
  const { id: i, options: t } = u();
  return /* @__PURE__ */ o(
    g,
    {
      align: "stretch",
      spacing: 0,
      ...e,
      role: "listbox",
      "aria-label": "Suggestions",
      id: `${i}-suggestions`,
      children: t == null ? void 0 : t.map((r, s) => /* @__PURE__ */ o(n, { suggestionIndex: s }, r.value))
    }
  );
};
export {
  p as AutoSuggestionList
};
